// Group department-shared contacts by department name for the webclient
// "Shared with me" view (#789). Pure, so the transform is unit-tested and the
// component only renders the result.
import type { SharedContact } from './api';

export function groupSharedByDepartment(rows: SharedContact[] | undefined): [string, SharedContact[]][] {
  const by: Record<string, SharedContact[]> = {};
  for (const row of rows || []) {
    (by[row.group_name] ||= []).push(row);
  }
  return Object.entries(by).sort((a, b) => a[0].localeCompare(b[0]));
}
